import { Controller } from "@hotwired/stimulus"
import { confirmWithDialog } from "../../src/admin/js/turbo-confirm-dialog"

export default class extends Controller {
  static values = {
    originalCode: String,
    confirmMessage: String
  }

  async confirmCodeChange (event) {
    if (this.confirmed) {
      this.confirmed = false
      return
    }
    if (!this.hasOriginalCodeValue || this.originalCodeValue.length === 0) return

    const codeInput = this.element.querySelector('input[name="site[code]"]')
    if (!codeInput) return
    if (codeInput.value === this.originalCodeValue) return

    // Held until the dialog answers, then submitted again past this check.
    event.preventDefault()
    event.stopImmediatePropagation()
    if (!(await confirmWithDialog(this.confirmMessageValue))) return

    this.confirmed = true
    this.element.requestSubmit(event.submitter)
  }
}
